import { fn2nZ } from '../../core/formatter/formatNumber';
import { getEmissionsFaktor } from '../../main/functions/getEmmissionsFaktor';
import { IDs } from '../../helpers/IDs';
import { Md5 } from 'ts-md5/dist/md5';
import * as Moment from 'moment';
import * as React from 'react';
import style from './ZusatzToolsCO2.less';
import styleWForm from '../../core/forms/style/WForm.less'
import { getCO2MehrkostenBase } from '../../main/functions/getCO2MehrkostenBase';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import { i18n } from '../../i18n/i18n';

export interface ZusatztoolsCO2Props {
    isEtool?: boolean;
    data?: any;
    onRoutingChange?: (routing: any) => void;
    dataIn?: any;
    externalIntro?: string; // Dateiname
    externalIntroHeight?: number;
}

export interface ZusatztoolsCO2State {
    verbrauch: any;
    preise: any;
    kosten: any;
    mode: string;
    eeg_reduzierung: any;
    lastMd5: string;
    jahr: number;
    co2preis: number;
}

export class ZusatztoolsCO2 extends React.Component<ZusatztoolsCO2Props, ZusatztoolsCO2State> {

    constructor(props: any) {
        super(props);
        this.state = {
            verbrauch: {},
            preise: {},
            kosten: {},
            mode: undefined,
            eeg_reduzierung: {},
            lastMd5: null,
            jahr: Moment().year() - 1,
            co2preis: null,
        };
        this.setVerbrauch = this.setVerbrauch.bind(this);
        this.setPreis = this.setPreis.bind(this);
        this.setKosten = this.setKosten.bind(this);
        this.setEEG = this.setEEG.bind(this);
        this.init = this.init.bind(this);
    }

    private eeg_default = 1.7;
    private sum_kosten = 0;
    private et_co2: any = {};
    private et_kwh: any = {};
    private sum_co2 = 0;
    private sum_jahr: number = 0;
    private verbrauchJahr: any = {};


    findRow(rows: Array<any>, jahr: number) {
        let rowFound: any = undefined;

        rows.forEach((row: any) => {
            // Wenn wir noch keine Row gefunden haben, nehmen wir die
            if (!rowFound) {
                rowFound = row;
                return;
            }
            // Wir hatten schonmal eine row gefunden
            if (rowFound.jahr > jahr && row.jahr <= jahr) {
                // Diese war größer als das Jahr, wir suchen aber eigentlich das Jahr, das gleich oder kleiner ist
                rowFound = row;
                return;
            }
            // Wir hatten schonmal eine Row, die gleich oder kleiner war
            if (rowFound.jahr < jahr && row.jahr <= jahr && row.jahr > rowFound.jahr) {
                rowFound = row; // Dieses Jahr ist besser
                return;
            }
        });
        return rowFound;
    }

    componentDidMount(): void {
        this.setState({ lastMd5: this.getMd5() }, this.init);
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (this.getMd5() !== this.state.lastMd5) {
            this.setState({ lastMd5: this.getMd5() }, this.init);
        }
        if (this.state.jahr !== prevState.jahr) {
            this.setState({ verbrauch: {}, preise: {}, kosten: {}, }, this.init);
        }
    }

    findAndSet(key_kenn: string, key_co2: string, mode: string, jahrUse: number): number {
        const kennzahlen = this.props.data[IDs.KENNZIFFERN_BERECHNET][jahrUse] || {};
        let found = 0;
        if (kennzahlen[key_kenn]) {
            if (mode === 'verbrauch') {
                found++;
                this.setVerbrauch(key_co2, Math.round(kennzahlen[key_kenn]), jahrUse);
            } else if (mode === 'kosten') {
                found++;
                this.setKosten(key_co2, kennzahlen[key_kenn]);
            }
        }
        return found;
    }

    getMd5(): string {
        return Md5.hashAsciiStr(JSON.stringify((this.props.data || {})[IDs.KENNZIFFERN_BERECHNET] || {})).toString();
    }

    getTranslation(): any {
        return {
            'Ottokraftstoff': { unit: 'Liter', name: 'Benzin' },
            'Diesel': { unit: 'Liter', name: 'Diesel' },
            'Heizöl (leicht)': { unit: 'Liter', name: 'Heizöl' },
            'Erdgas': { unit: 'kWh', name: 'Erdgas*' },
            'Flüssiggas': { unit: 'kWh', name: 'Flüssiggas*' }
        };
    }

    init(): void {
        if (!this.props.data) {
            return;
        }
        const jahrStart = this.state.jahr;
        for (let jahrUse = jahrStart; jahrUse > 2010; jahrUse--) {
            let found = 0;
            // Siehe getEnergietraegerKeyMap()
            found += this.findAndSet('diesel_verbrauch', 'diesel', 'verbrauch', jahrUse);
            found += this.findAndSet('diesel_kosten', 'diesel', 'kosten', jahrUse);
            found += this.findAndSet('benzin_verbrauch', 'ottokraftstoff', 'verbrauch', jahrUse);
            found += this.findAndSet('benzin_kosten', 'ottokraftstoff', 'kosten', jahrUse);
            // found += this.findAndSet('verbrauch_waerme_hel_kwh', 'heizoel_leicht', 'verbrauch', jahrUse);
            found += this.findAndSet('verbrauch_waerme_hel_liter_reversed', 'heizoel_leicht', 'verbrauch', jahrUse);
            found += this.findAndSet('kosten_waerme_hel', 'heizoel_leicht', 'kosten', jahrUse);
            found += this.findAndSet('verbrauch_waerme_fluessiggas_kwh', 'fluessiggas', 'verbrauch', jahrUse);
            found += this.findAndSet('kosten_waerme_fluessiggas', 'fluessiggas', 'kosten', jahrUse);
            found += this.findAndSet('verbrauch_waerme_erdgas_kwh', 'erdgas', 'verbrauch', jahrUse);
            found += this.findAndSet('kosten_waerme_erdgas', 'erdgas', 'kosten', jahrUse);
        }
    }

    render(): JSX.Element {
        // alert(window.innerWidth);
        this.et_co2 = {};
        this.et_kwh = {};
        this.sum_co2 = 0;
        this.sum_kosten = 0;
        this.sum_jahr = 0;
        const jahr = 2021;
        let energietraeger: Array<any> = [];
        if (this.props.isEtool) {
            const heizwerte = this.props.data[IDs.ENT_PARAMETER_HEIZWERTE];
            const heizwertRow: any = this.findRow(heizwerte, jahr);
            const base = getCO2MehrkostenBase();
            energietraeger = base.map((item: any) => {
                return {
                    key: item.key,
                    name: item.name,
                    faktor: getEmissionsFaktor(this.props.data, null, jahr, item.key),
                    heizwert: heizwertRow && heizwertRow[this.translateKeyForHeizwert(item.key)]
                        ? heizwertRow[this.translateKeyForHeizwert(item.key)]
                        : 1
                };
            });
        } else {
            energietraeger = this.props.dataIn;
        }
        return (
            <div>
                {this.renderIntro()}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {this.renderForm(energietraeger)}
                    {this.renderMehrkosten(energietraeger)}
                </div>
                {this.renderInfoText()}
            </div>
        );
    }

    renderForm(energietraeger: Array<any>) {
        const translation = this.getTranslation();

        return (
            <div className={style.form}>
                {this.renderFormTitel()}
                {this.renderFormHead()}
                {energietraeger.filter((et: any) => translation[et.name]).map((et: any, idx: number) =>
                    <React.Fragment key={`form-${idx}`}>{this.renderFormRow(et)}</React.Fragment>
                )}
                {this.renderFormSummen()}
            </div>
        );
    }

    renderFormHead() {
        const headClass = style.formHead;
        const headClassFirst = style.formHeadFirst;
        return (
            <div className={style.formRow}>
                <div className={headClassFirst}>
                    {i18n('Energieträger', 'sys')}
                </div>
                <div className={headClass}>
                    {i18n('Jahresverbrauch', 'sys')}
                </div>
                <div className={headClass}>
                    {i18n('Preis', 'sys')}
                </div>
                <div className={headClass}>
                    {i18n('Energiekosten pro Jahr', 'sys')}
                </div>
                <div className={headClass}>
                    {i18n('CO₂-Emissionen', 'sys')}
                </div>
            </div>
        );
    }
    renderFormRow(et: any) {
        const translation = this.getTranslation();
        const verbrauch = !isNaN(this.state.verbrauch[et.key]) ? this.state.verbrauch[et.key] : 0;
        const preis: any = !isNaN(this.state.preise[et.key]) ? +(this.state.preise[et.key]).toFixed(2) : '';
        const kosten: any = !isNaN(this.state.kosten[et.key]) ? +(this.state.kosten[et.key]).toFixed(2) : '';
        const heizwert = et.key !== 'fluessiggas' ? et.heizwert : 1;
        const verbrauch_kwh = verbrauch * heizwert;
        const co2 = (verbrauch_kwh * et.faktor);
        const name = translation[et.name].name;
        const unit = translation[et.name].unit;
        this.et_co2[et.key] = co2;
        this.et_kwh[et.key] = verbrauch_kwh;

        if (kosten && !isNaN(kosten)) {
            this.sum_kosten += kosten;
        }

        if (co2 && !isNaN(co2)) {
            this.sum_co2 += co2;
        }
        const formFieldFirstClass = style.formFieldFirst;
        const formFieldClass = style.formField;
        const inputNumberClass = style.inputNumber;
        return (
            <div className={style.formRow}>
                <div className={formFieldFirstClass}>{name}</div>
                <div className={formFieldClass}>
                    <input
                        type='number'
                        value={verbrauch}
                        onChange={(evt: any) => this.setVerbrauch(et.key, evt.target.value, null)}
                        className={inputNumberClass}
                    />
                    <span className={style.unitField}>{unit}</span>
                </div>
                <div className={formFieldClass}>
                    {this.state.mode === 'kosten'
                        ?
                        <div style={{ paddingTop: 3 }}>
                            <span>{fn2nZ(preis)}</span>
                            <span className={style.unitField}>€ / {unit}</span>
                        </div>
                        :
                        <>
                            <input
                                type='number'
                                value={preis}
                                onChange={(evt: any) => this.setPreis(et.key, evt.target.value)}
                                className={inputNumberClass}
                            />
                            <span className={style.unitField}>€ / {unit}</span>
                        </>
                    }
                </div>
                <div className={formFieldClass}>
                    {this.state.mode === 'preise'
                        ?
                        <div style={{ paddingTop: 3 }}>
                            <span>{fn2nZ(kosten)}</span>
                            <span className={style.unitField}>€</span>
                        </div>
                        :
                        <>
                            <input
                                type='number'
                                value={kosten}
                                onChange={(evt: any) => this.setKosten(et.key, evt.target.value)}
                                className={inputNumberClass}
                            />
                            <span className={style.unitField}>€</span>
                        </>
                    }
                </div>
                <div className={formFieldClass} style={{ padding: 3, paddingTop: 9 }}>
                    {fn2nZ(co2)}
                    <span className={style.unitField}>t</span>
                </div>
            </div>
        );
    }

    renderFormSummen() {
        const kosten = this.sum_kosten;
        const co2 = this.sum_co2;

        if (kosten && !isNaN(kosten)) {
            this.sum_kosten += kosten;
        }

        if (co2 && !isNaN(co2)) {
            this.sum_co2 += co2;
        }
        const formSummenFirstClass = style.formSummenFirst;
        const formSummenClass = style.formSummen;
        return (
            <div className={style.formRow}>
                <div className={formSummenFirstClass}>Summe</div>
                <div className={formSummenClass}>
                    &nbsp;
                </div>
                <div className={formSummenClass}>
                    &nbsp;
                </div>
                <div className={formSummenClass} style={{ padding: 3, paddingTop: 8 }}>
                    {fn2nZ(kosten)}
                    <span className={style.unitField}>€</span>
                </div>
                <div className={formSummenClass} style={{ padding: 3, paddingTop: 8 }}>
                    {fn2nZ(co2)}
                    <span className={style.unitField}>t</span>
                </div>
            </div>
        );
    }

    renderFormTitel() {
        return <div
            className={style.formTitel}
            style={{ width: 758 }}
        >
            {i18n('Energieträger und Energieverbrauch', 'sys')}
        </div>;
    }

    renderIntro() {
        return (
            <div className={style.intro}>
                {this.props.externalIntro
                    ?
                    <iframe
                        title='Intro'
                        src={this.props.externalIntro}
                        style={{
                            width: '100%', height: this.props.externalIntroHeight ? this.props.externalIntroHeight : '100%',
                            maxWidth: 1016, marginTop: 10, border: 0
                        }}
                    />
                    : <>{this.props.isEtool ? this.renderIntroText() : ''}</>
                }
            </div>
        );
    }

    renderIntroText() {
        return (
            <div className={style.introText}>
                {renderText('ZusatztoolsCO2_Info', this.props.data)}
            </div>
        );
    }

    renderInfoText() {
        return (
            <div className={style.introText} style={{ fontStyle: 'italic' }}>
                {renderText('ZusatztoolsCO2_Hinweis', this.props.data)}
            </div>
        );
    }

    renderMehrkosten(energietraeger: Array<any>) {
        const translation = this.getTranslation();

        return (
            <div className={style.form} style={{ marginLeft: 5 }}>
                {this.renderMehrkostenTitel1()}
                {this.renderMehrkostenTitel2()}
                {energietraeger.filter((et: any) => translation[et.name]).map((et: any, idx: number) =>
                    <React.Fragment key={`table-${idx}`}>{this.renderMehrkostenRow(et)}</React.Fragment>
                )}
                {this.renderMehrkostenSummen()}
            </div>
        );
    }

    renderMehrkostenRow(et: any) {
        const { jahr, co2preis } = this.state;

        let co2_kosten = 0;
        let co2_jahr = this.et_co2[et.key];
        if (this.verbrauchJahr[jahr] && this.verbrauchJahr[jahr][et.key]) {
            const heizwert = et.key !== 'fluessiggas' ? et.heizwert : 1;
            const verbrauch_kwh = this.verbrauchJahr[jahr][et.key] * heizwert;
            co2_jahr = (verbrauch_kwh * et.faktor);
        }
        if (et.key !== 'strom_mix' && this.et_co2[et.key] && co2preis > 0) {
            co2_kosten = co2_jahr * co2preis;
        }
        if (et.key === 'strom_mix') {
            const eeg = this.state.eeg_reduzierung[jahr] || this.eeg_default;
            const verbrauch = this.et_kwh[et.key];

            if (verbrauch) {
                co2_kosten = (eeg / 100) * verbrauch * -1;
            }
        }
        this.sum_jahr = (this.sum_jahr || 0) + co2_kosten;

        return (
            <div className={style.tableRow}>
                <div
                    key={`row-${jahr}`}
                    className={style.tableField}
                >
                    <span>{fn2nZ(co2_kosten)}</span>
                    <span className={style.unitField}>€</span>
                </div>
            </div>
        );
    }

    renderMehrkostenSummen() {
        return (
            <div className={style.tableRow}>
                <div className={style.tableFieldSumme}>
                    {fn2nZ(this.sum_jahr)}
                    <span className={style.unitField}>€</span>
                </div>
            </div>
        );
    }

    renderMehrkostenTitel1() {
        return (
            <div
                className={style.formTitel}
                style={{ width: 350 }}
            >
                {i18n('CO₂ - Mehrkosten für Brennstoffe', 'sys')}
            </div>
        );
    }

    renderMehrkostenTitel2() {
        const { jahr, co2preis } = this.state;
        return (
            <div className={style.tableRow}>
                <div className={style.mehrkostenTitelCell}>
                    <div>
                        <span style={{ marginRight: 5 }}>Jahr</span>
                        <div
                            className={styleWForm.inputNumberContainer}
                            style={{ width: 100, display: 'inline-flex' }}
                        >
                            <input
                                className={style.inputNumber}
                                style={{ paddingRight: 20 }}
                                type='number'
                                value={jahr}
                                onChange={(evt: any) => {
                                    const value = evt.target.value;
                                    if (!value) {
                                        this.setState({ jahr: null });
                                    } else {
                                        const jahr = Math.min(parseInt(value, 10), 3000);
                                        if (jahr > 0) {
                                            this.setState({ jahr });
                                        }
                                    }
                                }}
                            />
                            <div
                                className={styleWForm.arrowUp}
                                style={{ width: 15 }}
                                onClick={() => this.setState({ jahr: this.state.jahr + 1 })}
                                title={i18n('Mehr', 'sys')}
                            />
                            <div
                                className={styleWForm.arrowDown}
                                style={{ width: 15 }}
                                onClick={() => this.setState({ jahr: this.state.jahr - 1 })}
                                title={i18n('Weniger', 'sys')}
                            />
                        </div>
                    </div>
                    <div>
                        <span style={{ marginRight: 5 }}>CO₂ Preis [€/t]</span>
                        <input
                            type='number'
                            value={co2preis}
                            onChange={(evt: any) => {
                                const value = evt.target.value;
                                if (!value) {
                                    this.setState({ co2preis: null });
                                } else {
                                    const co2preis = parseInt(value, 10);
                                    if (co2preis > 0) {
                                        this.setState({ co2preis });
                                    }
                                }
                            }}
                            className={style.inputNumber}
                        />
                    </div>
                </div>
            </div>
        );
    }

    setEEG(jahr: number, value: number) {
        if (isNaN(value)) {
            value = undefined;
        }
        const eeg_reduzierung = this.state.eeg_reduzierung;
        eeg_reduzierung[jahr] = value;
        this.setState({ eeg_reduzierung });
    }

    setKosten(key: string, value: any) {
        const kosten = this.state.kosten;
        const preise = this.state.preise;
        const verbrauch = this.state.verbrauch;
        let mode = this.state.mode;

        if (value === '' || isNaN(value)) {
            delete (kosten[key]);
            delete (preise[key]);

            if (Object.keys(kosten).length + Object.keys(preise).length === 0) {
                mode = undefined;
            }
        } else {
            kosten[key] = +value;
            preise[key] = +value / verbrauch[key];
            mode = 'kosten';
        }
        this.setState({ preise, kosten, mode });
    }

    setPreis(key: string, value: any) {
        const kosten = this.state.kosten;
        const preise = this.state.preise;
        const verbrauch = this.state.verbrauch;
        let mode = this.state.mode;

        if (value === '' || isNaN(value)) {
            delete (preise[key]);
            delete (kosten[key]);

            if (Object.keys(kosten).length + Object.keys(preise).length === 0) {
                mode = undefined;
            }
        } else {
            kosten[key] = value * verbrauch[key];
            preise[key] = +value;
            mode = 'preise';
        }
        this.setState({ preise, kosten, mode });
    }

    setVerbrauch(key: string, value: any, jahr: number) {
        const kosten = this.state.kosten;
        const preise = this.state.preise;
        const verbrauch = this.state.verbrauch;
        const mode = this.state.mode;

        if (!this.verbrauchJahr[jahr]) { // Wenn es kein Jahr gibt, ist es immer der Eingabe-Wert
            this.verbrauchJahr[jahr] = {};
        }
        if (jahr) {
            this.verbrauchJahr[jahr][key] = +value;
        }
        if (!verbrauch[key] || !jahr) {
            verbrauch[key] = +value;
        }

        if (preise[key] && mode === 'preise') {
            kosten[key] = +value * preise[key];
        } else if (kosten[key] && mode === 'kosten') {
            preise[key] = kosten[key] / +value;
        }
        // console.log('V', verbrauch);
        this.setState({ verbrauch, kosten, preise });
    }

    translateKeyForHeizwert(key: string) {
        if (key === 'fluessiggas') { return 'fluessiggas_l'; }
        if (key === 'diesel') { return 'dieselkraftstoffe'; }
        if (key === 'ottokraftstoff') { return 'ottokraftstoffe'; }
        if (key === 'biomasse_holz') { return 'brennholz_hart'; }

        return key;
    }
}
